<div class="content">
    <page-header [title]="('admin.parametres.api.rest.details.compte.rest' | translate) + (libelleTitle ? (' : ' + libelleTitle) : '')"
                 [listeItems]="listeTabItems" [selectedIndex]="selectedIndex" (onSelectedItemChange)="onSelectedItemChange($event)"
                 [niveauAlerte]="apiRestDetailsService.compteApi?.verrouille ? alerteCompteVerrouille.niveau : null" (onGoBack)="onGoBack()">
        <preview-alerte *ngIf="apiRestDetailsService.compteApi?.verrouille" [alerte]="alerteCompteVerrouille" [withIcon]="'info_outline'"></preview-alerte>
    </page-header>
    <api-rest-details-compte *ngIf="selectedItem?.code === Onglets.COMPTE"></api-rest-details-compte>

    <!-- Onglet des droits -->
    <api-rest-details-droits *ngIf="selectedItem?.code === Onglets.DROITS"></api-rest-details-droits>
</div>
<floating-button [listeActions]="listeActions" *ngIf="listeActions"></floating-button>